import React, { useState } from 'react';
import { Button } from 'devextreme-react';

const RenderBox = ({ title, amount, id, count, onCountChange }: { title: string, amount: number, id: string, count: number, onCountChange: (id: string, value: number) => void }) => {
  return (
    <div className='content-box'>
      <div className='title-box'>{title} </div>
      <div className='amount-box'>{amount} $ </div>
      <div className='content-counter'>
        <div className='decount'>
          <Button
            icon="minus"
            width={20}
            type="normal"
            onClick={() => onCountChange(id, -1)}
          />
        </div>
        <div className={"value-counter " + (count < 0 ? 'negative-counter' : '') + (count > 0 ? "positive-counter" : "")}>
          {count}
        </div>
        <div className='count'>
          <Button
            icon="plus"
            width={20}
            type="normal"
            onClick={() => onCountChange(id, 1)}
          />
        </div>
      </div>
    </div>
  );
};

export default RenderBox;